module.exports = __webpack_public_path__ + "media/images/sales/smakon/thumb-pricing-01-a1e1fc5ee3b9963daf6668c7eab8e0bb.svg";